import { useCallback, useState } from 'react'

const useModal = (isInitialOpen = false) => {
    const [isModalOpen, setIsModalOpen] = useState(isInitialOpen)

    const handleOpenModal = useCallback(() => setIsModalOpen(true), [])
    const handleCloseModal = useCallback(() => setIsModalOpen(false), [])

    return { isModalOpen, handleOpenModal, handleCloseModal }
}

export default useModal
